module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"MenuHorizontal":{"heading":"Kategorie"}},"de":{"MenuHorizontal":{"heading":"Kategorien"}},"sk":{"MenuHorizontal":{"heading":"Kategórie"}}}')
  delete Component.options._Ctor
}
